import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/photos/landscape-blur-3200.jpg'
import _imports_1 from '@/assets/photos/landscape-blur-2400.jpg'
import _imports_2 from '@/assets/photos/landscape-blur-1600.jpg'
import _imports_3 from '@/assets/photos/landscape-blur-1200.jpg'
import _imports_4 from '@/assets/photos/landscape-blur-800.jpg'
import _imports_5 from '@/assets/onlyoneprod-logo.svg'


const _hoisted_1 = _imports_0 + ' 3200w, ' + _imports_1 + ' 2400w, ' + _imports_2 + ' 1600w, ' + _imports_3 + ' 1200w, ' + _imports_4 + ' 800w'
const _hoisted_2 = { class: "content back-blur" }

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionHero',
  setup(__props) {

const heroElement = ref<HTMLElement>();
const contentElement = ref<HTMLElement>();

onMounted(() => {
    if (!heroElement.value || !contentElement.value) {
        return;
    }

    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && contentElement.value) {
            contentElement.value.classList.add('show');
        }
    });
    observer.observe(heroElement.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: "hero",
    class: "screen",
    ref_key: "heroElement",
    ref: heroElement
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      class: "background",
      src: _imports_0,
      srcset: _hoisted_1
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "center",
        ref_key: "contentElement",
        ref: contentElement
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_5,
          alt: "Only One Prod",
          class: "logo"
        }, null, -1)),
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ])
  ], 512))
}
}

})